import { useLocation } from 'react-router';

import { AIOppAvailableChart } from '../../charts/AIOppAvailableChart';
import { AIViewRateChart } from '../../charts/AIViewRateChart';
import { ConversionRateChart } from '../../charts/ConversionRateChart';
import { mapRates } from '../../helpers/benchmarking/mapRates';
import { useProviderRates } from '../../helpers/benchmarking/providerRates';
import { useGetFilteredClinicalData } from '../../helpers/data/getClinicalData';
import { PracticeHeader } from '../PracticeHeader';

import { PracticeBenchmarkTable } from './PracticeBenchmarkTable';

export const PracticeBenchmarks = () => {
  const location = useLocation();
  const id =
    location.pathname.split('practice/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('practice/')[1]?.split('/')[0];

  const practiceRates = useProviderRates({
    practices: id ? [id] : undefined,
    isDataFiltered: true,
  });

  const { data: clinicalData } = useGetFilteredClinicalData({
    isPracticesEnabled: false,
    isTreatmentsEnabled: false,
    isProviderRoleEnabled: false,
    isMaterialityEnabled: false,
  });

  const name = clinicalData?.practices?.find(
    (practice) => practice?.practiceVideaId.toString() === id,
  )?.practiceName;

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-h-full vai-px-8 vai-py-4">
      <PracticeHeader practiceName={name} />
      <div className="vai-flex vai-flex-row vai-justify-between vai-w-full">
        <div className="vai-flex vai-flex-col vai-w-[33%] vai-gap-4">
          <AIOppAvailableChart practices={id ? [id] : undefined} />
          <AIViewRateChart practices={id ? [id] : undefined} />
        </div>
        <ConversionRateChart
          level="Practice"
          practices={id ? [id] : undefined}
        />
      </div>
      <PracticeBenchmarkTable
        data={
          practiceRates.providerRates?.map((provider) =>
            mapRates(
              provider,
              provider.providerId,
              provider.providerName,
              provider.practiceId,
              provider.practiceName,
            ),
          ) ?? []
        }
        isLoading={practiceRates.isLoading}
        practiceName={name}
      />
    </div>
  );
};
